<template>
  <div class="diagram">
    <button class="diagram__row" type="button" v-on:click.self="showDiagram = !showDiagram">
      <h2 class="diagram__caption">
        <button
          @click="showDiagram = !showDiagram"
          type="button"
        >
          {{ title }}
        </button>
      </h2>
      <div class="diagram__filter">
        <div v-show="showDiagram">
          <label class="diagram__radio bar">
            <input type="radio" name="diagram" value="bar" v-model="diagramType"><span />
          </label>
          <label class="diagram__radio pie">
            <input type="radio" name="diagram" value="pie" v-model="diagramType"><span />
          </label>
        </div>
        <button
          class="diagram__show"
          type="button"
          v-on:click="showDiagram = !showDiagram"
          v-bind:class="{ active: showDiagram }"
        />
      </div>
    </button>
    <div v-if="showDiagram" class="diagram__content">
      <sales-circle
        v-if="diagramType === 'pie'"
        v-bind:items="items"
        v-bind:item-label-key="itemLabelKey"
        v-bind:item-value-key="itemValueKey"
        v-bind:plugins="plugins"
      />
      <sales-bar
        v-else-if="diagramType === 'bar'"
        v-bind:items="items"
        v-bind:item-label-key="itemLabelKey"
        v-bind:item-value-key="itemValueKey"
        v-bind:plugins="plugins"
      />
    </div>
  </div>
</template>

<script>
import SalesCircle from '@/components/SalesCircle.vue';
import SalesBar from '@/components/SalesBar.vue';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  BarElement,
  LinearScale,
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  BarElement,
  LinearScale,
);

ChartJS.defaults.plugins.legend.position = 'left';
ChartJS.defaults.plugins.legend.align = 'start';
ChartJS.defaults.plugins.legend.labels.usePointStyle = true;
ChartJS.defaults.plugins.legend.labels.pointStyle = 'rect';
ChartJS.defaults.plugins.legend.onHover = function _(e) {
  e.native.target.style.cursor = 'pointer';
};

ChartJS.defaults.plugins.legend.onLeave = function _(e) {
  e.native.target.style.cursor = '';
};

export default {
  name: 'PieAndBarDiagram',
  components: { SalesBar, SalesCircle },
  data() {
    return {
      showDiagram: this.initialShowDiagram,
      diagramType: 'pie',
    };
  },
  props: {
    initialShowDiagram: { type: Boolean, default: () => false },
    items: { type: Array, default: () => [] },
    itemLabelKey: { type: String, default: () => 'label' },
    itemValueKey: { type: String, default: () => 'value' },
    plugins: { type: Object, default: () => {} },
    title: { type: String, default: () => 'Диаграммы' },
  },
};
</script>

<style scoped lang="scss">

.diagram {
  border: 1px solid #EAEFF3;
  border-radius: 10px;
  padding: 30px 22px 30px 34px;
  &__row {
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    column-gap: 50px;
    row-gap: 20px;
    width: 100%;
  }
  &__filter {
    display: flex;
    flex-direction: row;
    gap: 34px;
  }
  &__show {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    max-width: 48px;
    height: 48px;
    max-height: 48px;
    border: 1px solid #0489E0;
    border-radius: 4px;
    background-image: url("@/assets/img/checked/show-blue.svg");
    transform: rotate(180deg);
    background-position: center;
    &:hover {
      transform: rotate(0deg);
    }
    &.active {
      border: 1px solid #C2CFE0;
      background-image: url("@/assets/img/checked/show-grey.svg");
      transform: rotate(0deg);
      &:hover {
        border: 1px solid #0489E0;
        transform: rotate(180deg);
        background-image: url("@/assets/img/checked/show-blue.svg");
      }
    }
  }
  &__radio {
    &.pie {
      &>span {
        &::before {
          border-radius: 0 4px 4px 0;
          background-image: url("@/assets/img/diagram/pie-grey.svg");
          border-left: none;
        }
      }
      &>input {
        &:checked+span::before {
          border-color: #0489E0;
          background-image: url("@/assets/img/diagram/pie-blue.svg");
          border-left: 1px solid #0489E0;
        }
        &:not(:disabled):not(:checked)+span:hover::before {
          background-image: url("@/assets/img/diagram/pie-blue.svg")
        }
      }
    }
    &.bar {
      &>span {
        &::before {
          border-radius: 4px 0 0 4px;
          background-image: url("@/assets/img/diagram/bar-grey.svg");
          border-right: none;
        }
      }
      &>input {
        &:checked+span::before {
          border-color: #0489E0;
          background-image: url("@/assets/img/diagram/bar-blue.svg");
          border-right: 1px solid #0489E0;
        }
        &:not(:disabled):not(:checked)+span:hover::before {
          background-image: url("@/assets/img/diagram/bar-blue.svg");
        }
      }
    }
    &>input {
      position: absolute;
      z-index: -1;
      opacity: 0;
    }
    &>span {
      display: inline-flex;
      align-items: center;
      user-select: none;
      cursor: pointer;
      &::before {
        content: '';
        display: inline-block;
        width: 48px;
        height: 48px;
        flex-shrink: 0;
        flex-grow: 0;
        border: 1px solid #C2CFE0;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 50% 50%;
      }
    }
  }
  &__content {
    margin: 30px 0 20px 0;
    canvas {
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 480px) {
  .diagram {
    padding: 30px 10px;
  }
}
</style>
